import {
  DEFAULT_INDICES_TAB_VALUE,
  normalizeIndicesTabValue,
  type IndicesTabValue,
} from '@constants/indicesTabs';
import { getIframeQueryParamsFromSearch, type IframeQueryParams } from './queryParams';
import {
  WIDGET_ERROR_MESSAGES,
  type WidgetErrorKey,
} from './widgetErrorMessages';

export type IndicesParamIssueReason = 'missing_token';

export interface IndicesParamValidationIssue {
  param: WidgetErrorKey;
  reason: IndicesParamIssueReason;
  message: string;
}

export interface IndicesParamValidationResult {
  query: IframeQueryParams;
  tab: IndicesTabValue;
  needsTabNormalization: boolean;
  issues: IndicesParamValidationIssue[];
  isValid: boolean;
}

/**
 * Validates the standalone indices route only. Unlike Analysis, indices has no
 * instrument context. A token is required; missing/invalid tabs default to World.
 */
export const validateIndicesParams = (
  search: string,
): IndicesParamValidationResult => {
  const query = getIframeQueryParamsFromSearch(search);
  const parsedTab = normalizeIndicesTabValue(query.tab);
  const issues: IndicesParamValidationIssue[] = [];

  if (!query.token) {
    issues.push({
      param: 'token',
      reason: 'missing_token',
      message: WIDGET_ERROR_MESSAGES.token,
    });
  }

  return {
    query,
    tab: parsedTab ?? DEFAULT_INDICES_TAB_VALUE,
    needsTabNormalization: parsedTab === undefined,
    issues,
    isValid: issues.length === 0,
  };
};
